export const about = "W naszej Parafii posługę duszpasterską pełnią: proboszcz ks. Mikołaj Węgrzyn, wikariusz ks. Błażej Małolepszy, ks. Jan Fronczak oraz ks. Marek Madej."

export const priests = [
    {
      id: 1,
      name: "ks. kan. dr Mikołaj Węgrzyn",
      onlyName: "Mikołaj Węgrzyn",
      born: "1973, Częstochowa",
      prezb: "17.05.1997",
      image: "./assets/proboszcz.png",
      role: "Proboszcz",
      description: `Proboszcz Parafii od 1 lipca 2023 roku. Doktor teologii fundamentalnej, wykładowca w Instytucie Wyższych Studiów Teologicznych w Częstochowie. Członek Komisji do Spraw Muzyki Kościelnej Archidiecezji Częstochowskiej. W latach 2014–2023 Rektor Kościoła Rektorackiego pw. Najświętszego Imienia Maryi w Częstochowie.`,
      page: "https://open.spotify.com/show/15ZgO9tgXx0bniW9HbcKgA?si=e8d85f4a42394322",
      pageLabel: "Homilie wygłoszone w Kościółku Rektorackim można odsłuchać na platformie Spotify."
    },
    {
      id: 2,
      name: "ks. dr Błażej Małolepszy",
      onlyName: "Błażej Małolepszy",
      born: "1985, Wieluń",
      prezb: "22.05.2010",
      image: "./assets/wikariusz.png",
      role: "Wikariusz",
      description: `W Parafii od 1 lipca 2026 roku. Wcześniej pełnił posługę duszpasterską w Parafii Św. Rocha w Rząśni, Parafii Św. Stanisława Kostki w Zawierciu oraz Parafii Najświętszej Maryi Panny Zwycięskiej w Częstochowie. Doktor teologii fundamentalnej, wykładowca w Instytucie Wyższych Studiów Teologicznych w Częstochowie. Jego kapłańskie hasło to słowa z Pieśni nad Pieśniami: `,
      quote: `"Połóż mnie jak pieczęć na twoim sercu".`
    },
    {
      id: 3,
      name: "ks. prał. Jan Fronczak",
      onlyName: "Jan Fronczak",
      born: "1936, Eligiów",
      prezb: "29.06.1959",
      image: "./assets/ksiadz.jpg",
      description: `W Parafii od 2008 roku. W jego posłudze duszpasterskiej szczególne miejsce zajmuje sakrament pokuty i pojednania. Posługiwał na placówkach duszpasterskich w Dźbowie, Kromołowie, w Kolegiacie Wieluńskiej, oraz w Częstochowie w parafii pw. Św. Jakuba. W latach 1979 - 2008 był Proboszczem Parafii Św. Teresy od Dzieciątka Jezus w Niechcicach.`
    }
  ]